import api from "../../../../lib/api";
import { ICreateAwbDataApi, IGetAwbList } from "../../../../types/operations/awbInterface";

export const getAwbListingApi = (data: IGetAwbList) => {
  return api.get(`operations/awb/${data.page}/${data.pageLimit}`, {
    params: {
      search: data?.search,
      customer_id: data?.customerId,
      vendor_id: data?.vendorId,
      branch_id: data?.branchId,
      from_date: data?.fromDate,
      to_date: data?.toDate,
      awb_state: data?.awbState,
      service_mode: data?.serviceMode,
    },
  });
};

export const createAwbDataApi = (data: ICreateAwbDataApi & { edd?: string | null; add?: string | null }) => {
  const payload: any = { ...data };
  if (!data.edd) delete payload.edd;
  if (!data.add) delete payload.add;

  return api.post("operations/awb", payload);
};

export const updateAwbDataApi = ({ id, data }: { id: string; data: any }) => {
  const payload: any = { ...data };
  if (!data.edd) delete payload.edd;
  if (!data.add) delete payload.add;

  return api.put(`operations/awb/${id}`, payload);
};

export const downloadAwbApi = (id: number) => {
  return api.get(`/operations/awb/print`, {
    responseType: "blob",
    params: {
      awb_id: id,
    },
  });
};

export const getAwbByIdApi = (id: string) => {
  return api.get(`/operations/awb/${id}`);
};

export const getAWBIdByAWBNumber = (number: string) => {
  return api.get(`operations/awb/number/${number}`);
};

export const deletePodApi = (id: string | number) => {
  return api.delete(`operations/awb/pod`, {
    params: { awb_id: id },
  });
};

export const getAwbReport = (payload: {
  customer_id: number[];
  from_date: string;
  to_date: string;
  vendor_id?: number[];
  branch_id?: number[];     
  awb_state?: string[]; 
}) => {
  return api.post(`operations/awb/export`, payload, {
    responseType: "blob",
  });
};

export const getTestTrackingApi = (payload: { forwardingNumber: string; vendorCode: string }) => {
  return api.get(`/vendor-api/test-tracking`, {
    params: payload
  });
};

export const getPodByVendorApi = (payload: { forwardingNumber: string; vendorCode: string }) => {
  return api.get(`/vendor-api/pod`, {
    params: payload
  });
};

export const getPreviewVolumetricWeightApi = (payload: {
  slots: { length: number; width: number; height: number; quantity: number }[];
  total_actual_weight: number;
  shipment_dimension: string;
}) => {
  return api.post(`/operations/awb/preview-volumetric-weight`, payload);
};






